import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useGetUserMeta } from "@/api/queries";
import useDomainConfigAuth from "@/api/sanity/queries/getSiteConfigWithDomain";
import AuthPrimaryButton from "@/components/AuthPrimaryButton";
import BackButton from "@/components/BackButton";
import P from "@/components/P";
import Radio from "@/components/Radio";
import Spacer from "@/components/Spacer";
// import AppState from "@/store/appstate";
import useAppStore from "@/store/appStateZustand";

function AddAccount4() {
  const { t } = useTranslation("onboarding");
  const navigate = useNavigate();
  const userMeta = useGetUserMeta();
  const addAccount = useAppStore(s => s.addAccount || {});
  const [pending, setPending] = useState(false);
  const { data: domainConfig } = useDomainConfigAuth();

  if (domainConfig?.hide_gig_integrations) {
    navigate({ to: "/add-account-6" });
  }

  let title = t("onboarding:perform-live-header1");
  let desc = t("onboarding:perform-live-desc1");
  switch (userMeta?.data?.role) {
    case "Manager":
      title = t("onboarding:perform-live-header2");
      desc = t("onboarding:perform-live-desc2");
      break;
    default:
      break;
  }

  const handleNext = () => {
    setPending(true);
    navigate({ to:
      addAccount.live === true ? "/add-account-5" : "/add-account-6" });
  };

  return (
    <div className="container mx-auto">
      <div className="flex flex-col items-center justify-center p-4 text-center text-white min-h-screen-minus-footer">
        <h1 className="text-6xl">{title}</h1>
        <Spacer thin />
        <P>{desc}</P>
        <Spacer />
        <Radio
          name="live"
          placeholder=""
          value={addAccount.live}
          onChange={(e) => {
            const boolValue = e.target.value === "true";
            useAppStore.setState(state => ({
              addAccount: { ...state.addAccount, live: boolValue },
            }));
          }}
          options={[
            { label: t("common:yes"), value: true },
            { label: t("common:no"), value: false },
          ]}
        />
        <Spacer />
        <div className="w-full lg:w-1/3">
          <div className="flex flex-row items-center justify-evenly">
            <BackButton onClick={() => navigate({ to: "/add-account-3" })}>
              {t("onboarding:back-button")}
            </BackButton>
            <AuthPrimaryButton
              disabled={pending || typeof addAccount.live !== "boolean"}
              pending={pending}
              onClick={handleNext}
              arrow
            >
              {t("onboarding:next-step-button")}
            </AuthPrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AddAccount4;
